import React, { useEffect, useState } from "react";
import {
  ApiDelete,
  ApiGet,
  ApiPost,
  ApiPut,
} from "../../../helpers/API/ApiData";
import DataTable, { defaultThemes } from "react-data-table-component";
import CreateIcon from "@material-ui/icons/Create";
import DeleteIcon from "@material-ui/icons/Delete";
import { Button, Dropdown } from "react-bootstrap";
import { getUserInfo } from "../../../utils/user.util";
import { Modal } from "react-bootstrap";
import Dialog from "@material-ui/core/Dialog";
import List from "@material-ui/core/List";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./PromoCode.scss";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PromoCode = () => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
    setSubmitValue(false);
    setUpdateProduct(true);
    setImage("");
    setDesc("");
    setTitle("");
  };

  const handleClose1 = () => {
    setOpen(false);
  };

  const [coupon, setCoupon] = useState({
    couponId: "",
    code: "",
    max_redemptions: "",
    expires_at: "",
    metadata: "",
  });
  

  const [loading, setLoading] = useState(false);
    const [loaderHas, setLoaderHas] = useState(false);
  const [allProduct, setAllProduct] = useState();
  const [dataChange, setDataChange] = useState([]);
  const [coupons, setCoupons] = useState([]);
  const [pid, setPid] = useState();
  const [size, setSize] = useState();
  const [size1, setSize1] = useState([]);
  const [price, setPrice] = useState();
  const [type, setType] = useState();
  const [title, setTitle] = useState();
  const [image, setImage] = useState("");
  const [desc, setDesc] = useState();
  const [updateProduct, setUpdateProduct] = useState(false);
  const [submitValue, setSubmitValue] = useState(false);
  const [errors, setErrors] = useState({});
  const [OpenImages, setOpenImages] = useState();
  // const [errors] = useState([]);
  let userInfo = getUserInfo();

  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = (id) => {
    setShow(true);
    setPid(id);
  };

  useEffect(() => {
    getProductData();
    getCoupens();
  }, [dataChange]);

  const formValidator = () => {
    let isValid = true;
  
    setErrors({}); // Clear previous errors
  
    // Validate couponId
    if (!coupon.couponId?.trim()) {
      setErrors((cv) => ({
        ...cv,
        couponId: "Please enter a valid coupon ID",
      }));
      isValid = false;
    }
  
    // Validate code
    if (!coupon.code?.trim()) {
      setErrors((cv) => ({
        ...cv,
        code: "Please enter a valid coupon code",
      }));
      isValid = false;
    }
  
    // Validate max_redemptions
    if (
      coupon.maxRedemptions &&
      (isNaN(coupon.maxRedemptions) || Number(coupon.maxRedemptions) <= 0)
    ) {
      setErrors((cv) => ({
        ...cv,
        maxRedemptions: "Max redemptions must be a number greater than 0",
      }));
      isValid = false;
    }
  
    // Validate expires_at as a valid date (if provided)
    if (coupon.expires_at && isNaN(Date.parse(coupon.expires_at))) {
      setErrors((cv) => ({
        ...cv,
        expires_at: "Please enter a valid expiration date",
      }));
      isValid = false;
    }
  
    // Validate metadata (optional but ensure it's an object or empty)
    if (coupon.metadata && typeof coupon.metadata !== "object") {
      setErrors((cv) => ({
        ...cv,
        metadata: "Metadata must be an object",
      }));
      isValid = false;
    }
  
    return isValid;
  };
  



  const getCoupens = async () => {
    await ApiGet("webhook/get-coupon")
      .then((res) => {
        console.log("vaidhab---------------------", res.data.payload);

        setCoupons(res.data.payload?.coupons)
        // setAllProduct(res.data.payload?.coupons);
        // setUserReport(res.data.payload?.coupons);
        // // setFilteredReport(res.data.payload?.coupons);

        // const stripeCoupons = res.data.payload?.coupons;

        // const formatted = stripeCoupons.map((coupon) => ({
        //   couponDescription: coupon.metadata.name || `Coupon ${coupon.id}`,
        //   discountType: coupon.percent_off ? "Percent" : "Amount",
        //   discountValue: coupon.percent_off || coupon.amount_off || "N/A",
        //   duration:
        //     coupon.duration == "forever" ? "sponsored" : coupon.duration,
        //   durationInMonths: coupon.duration_in_months || "N/A",
        //   maxRedemptions: coupon.max_redemptions || "Unlimited",
        //   redeemBy: coupon.redeem_by
        //     ? new Date(coupon.redeem_by * 1000).toLocaleDateString()
        //     : "No Expiry",
        //   updatedAt: coupon.created * 1000,
        //   _id: coupon.id,
        // }));

        // setFilteredReport(formatted);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getProductData = async () => {
    await ApiGet("webhook/get-all-promo-codes")
      .then((res) => {
        console.log("vaidhab---------------------", res.data.payload);
        setAllProduct(res.data.payload?.promoCodes);
        setUserReport(res.data.payload?.promoCodes);
  
        const stripeCoupons = res.data.payload?.promoCodes?.data;
  
        console.log("stripeCoupons", stripeCoupons);
  
        const formatted = stripeCoupons.map((coupon) => ({
          code: coupon?.code,
          discountType: coupon?.coupon?.percent_off ? "Percent" : "Amount",
          discountValue: coupon?.coupon?.percent_off || coupon?.coupon?.amount_off || "N/A",
          duration: coupon?.coupon?.duration === "forever" ? "Sponsored" : coupon?.coupon?.duration || "-",
          durationInMonths: coupon?.duration_in_months || "N/A",
          maxRedemptions: coupon?.max_redemptions || "Unlimited",
          redeemBy: coupon?.redeem_by
            ? new Date(coupon?.redeem_by * 1000).toLocaleDateString()
            : "No Expiry",
          updatedAt: new Date(coupon?.created * 1000).toLocaleDateString(),
          _id: coupon?.id,
          timesRedeemed: coupon?.times_redeemed || 0,
        }));
  
        setFilteredReport(formatted);
      })
      .catch((err) => {
        console.log("Error fetching promo codes:", err);
      });
  };
  

  console.log("couponcouponcoupon", coupon);
  const handleDeleteProduct = async () => {
    // const data = {
    //   id: id,
    // };

    setLoaderHas(true);
    await ApiDelete(`webhook/delete-promo-code/${pid}`)
      .then((res) => {
        getProductData()
        setLoaderHas(false);
        handleClose();
        // setDataChange([...dataChange, "Music delete"]);
        //console.log(res.data.data);
      })
      .catch((err) => {
        setLoaderHas(false);
        console.log("err");
      });
  };

  console.log("couponcoupon", coupon);
  const submitProduct = async () => {
    if (!formValidator()) {
      console.log("ERROR PUT", errors);
      return;
    }
    setLoading(true);

    await ApiPost("webhook/create-promo-code", coupon)
      .then((res) => {
        setOpen(false);
        setUpdateProduct(false);
        setDataChange([...dataChange, "Product Added"]);

        setLoading(false);
        //console.log(res);
        setSize();
        setPrice();
        setType();
        setTitle();
        setImage();
        toast.success("Legend Add successfully");
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
        console.log(err);
      });
  };

  const handleForUpdateProduct = async (id) => {
    setOpen(true);
    setPid(id);
    setSubmitValue(true);

    await ApiGet(`legend/id=${id}`)
      .then((res) => {
        //console.log(res.data.data);
        //setAllMusic(res.data.data);
        setTitle(res.data.data.title);
        setDesc(res.data.data.description);
        setPrice(res.data.data.price);
        setSize1(res.data.data.size);
        setType(res.data.data.type);
        setOpenImages(res.data.data.legendsIcon);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getNewDate = (date) => {
    var d = new Date(date);
    var month = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    var newDate = `${month[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
    return newDate;
  };

  const handleUpdateProduct = async () => {
    setLoading(true);
    const formData = new FormData();
    formData.append("legendsName", title);
    formData.append("profileImage", image);
    formData.append("legendsDescription", desc);

    // const data = {
    //   legendsName: title,
    //   legendsIcon: image,
    //   legendsDescription: desc,
    // };

    await ApiPut(`legend/id=${pid}`, formData, {
      "Content-Type": "multipart/form-data",
    })
      .then((res) => {
        setOpen(false);
        setUpdateProduct(false);
        setDataChange([...dataChange, "Music Updated"]);
        setLoading(false);

        //console.log(res);
        setTitle();
        setDesc();
        setPrice();
        setSize1();
        setType();
        toast.success("legend Update successfully!");
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
        console.log(err);
      });
  };
  let i = 0;
  const columns = [
    {
      name: "S.No.",
      cell: (row, index) => index + 1,
      width: "80px",
    },
    {
      name: "Promo Code",
      selector: "code",
      wrap: true,
      sortable: true,
    },
    {
      name: "Discount Type",
      cell: (row) => (row?.discountType),
      sortable: true,
    },
    {
      name: "Discount Value",
      cell: (row) => row?.discountValue,
      sortable: true,
    },
    {
      name: "Duration",
      selector: "duration",
      sortable: true,
    },
    {
      name: "Times Redeemed",
      selector: "timesRedeemed",
      sortable: true,
    },


    {
        name: "Max Redemptions",
        selector: "maxRedemptions",
        sortable: true,
      },
    {
      name: "Actions",
      cell: (row) => {
        return (
          <>
            <div className="d-flex justify-content-between">
              <div
                className="cursor-pointer mr-3"
                onClick={() => {
                  handleShow(row.id);
                }}
              >
                <DeleteIcon />
              </div>
              {/* <div
                className="cursor-pointer"
                onClick={() => {
                  setUpdateProduct(true);
                }}
              >
                <CreateIcon />
              </div> */}
            </div>
          </>
        );
      },
      sortable: true,
    },
  ];
  

  //* Table Style
  const customStyles = {
    header: {
      style: {
        minHeight: "56px",
      },
    },
    headRow: {
      style: {
        borderTopStyle: "solid",
        borderTopWidth: "1px",
        borderTopColor: defaultThemes.default.divider.default,
      },
    },
    headCells: {
      style: {
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
          borderRightColor: defaultThemes.default.divider.default,
        },
      },
    },
    cells: {
      style: {
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
          borderRightColor: defaultThemes.default.divider.default,
        },
      },
    },
  };

  const handleSize = () => {
    setSize("");
    console.log(size);
    setSize1([...size1, size]);
  };
  console.log(size1);

  const [userReport, setUserReport] = useState();
  const [filteredReport, setFilteredReport] = useState();

  const handleSearch = (e) => {
    console.log("eeeee", e.target.value);
    var value = e.target.value.toLowerCase();
    setFilteredReport(() =>
      userReport.filter(
        (item) =>
          item?.legendsDescription?.toLowerCase().includes(value) ||
          item?.legendsName?.toLowerCase().includes(value)
        // item?.phone?.toLowerCase().includes(value)
      )
    );
  };

  console.log("DATAAAAAA", filteredReport, submitValue);

  return (
    <>
      <ToastContainer />
      <div>
        {/*  */}
        <div className="card p-1">
          <div className="p-2">
            <div className="row mb-4 pr-3">
              <div className="col d-flex justify-content-between">
                <h2 className="pl-3 pt-2">All Promo Codes</h2>
              </div>
              <div className="col">
                <div>
                  <input
                    type="text"
                    className={`form-control form-control-lg form-control-solid `}
                    name="title"
                    placeholder="Search Legends"
                    onChange={(e) => handleSearch(e)}
                  />
                </div>
              </div>
              <div className="cus-medium-button-style button-height">
                <button
                  className="btn btnColor"
                  onClick={() => {
                    handleClickOpen();
                  }}
                >
                  Add Promo Code
                </button>
              </div>
            </div>
          </div>
          <DataTable
            columns={columns}
            data={filteredReport}
            customStyles={customStyles}
            pagination
            style={{
              marginTop: "-3rem",
            }}
          />
        </div>
        {/*  */}
      </div>
      <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title className="text-danger">Alert!</Modal.Title>
            </Modal.Header>
            <Modal.Body>Are you sure want to delete Promo Code?</Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Cancle
              </Button>
              <Button variant="danger" disabled={loaderHas} onClick={() => handleDeleteProduct()}>
                Delete
                {loaderHas && (
                    <span className="mx-3 spinner spinner-white"></span>
                  )}
              </Button>
            </Modal.Footer>
          </Modal>

      <Dialog
        fullScreen
        open={open}
        onClose={handleClose1}
        TransitionComponent={Transition}
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose1}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>

        <List>
  {updateProduct && updateProduct === true ? (
    <div className="form ml-30">
      {/* Instructions */}
      <div className="form-group row">
        <div className="col-lg-9 col-xl-6 offset-xl-3">
          <p style={{
            fontSize: "14px",
            color: "#6c757d",
            fontStyle: "italic",
            lineHeight: "1.6",
          }}>
            <strong style={{ fontSize: "16px", color: "#343a40" }}>
              Coupon Form Instructions:
            </strong>
            Use this form to update coupon details such as the code, expiration date,
            and redemption limits.
          </p>
        </div>
      </div>

      {/* Select Existing Coupon ID */}

      {console.log("couponscoupons",coupons)}
      <div className="form-group row">
        <label className="col-xl-3 col-lg-3 col-form-label">Select Coupon</label>
        <div className="col-lg-9 col-xl-6">
          <select
            className="form-control form-control-lg form-control-solid"
            value={coupon.couponId}
            onChange={(e) => setCoupon({ ...coupon, couponId: e.target.value })}
          >
            <option value="">-- Select a Coupon --</option>
            {coupons.map((c) => (
              <option key={c.id} value={c.id}>
                {c.metadata.name || c.id}
              </option>
            ))}
          </select>
          {errors?.couponId && (
            <small className="text-danger">{errors.couponId}</small>
          )}
        </div>
      </div>

      {/* Coupon Code */}
      <div className="form-group row">
        <label className="col-xl-3 col-lg-3 col-form-label">Coupon Code</label>
        <div className="col-lg-9 col-xl-6">
          <input
            type="text"
            className="form-control form-control-lg form-control-solid"
            value={coupon.code}
            onChange={(e) => setCoupon({ ...coupon, code: e.target.value })}
          />
          {errors?.code && (
            <small className="text-danger">{errors.code}</small>
          )}
        </div>
      </div>

      {/* Max Redemptions */}
      <div className="form-group row">
        <label className="col-xl-3 col-lg-3 col-form-label">Max Redemptions</label>
        <div className="col-lg-9 col-xl-6">
          <input
            type="number"
            className="form-control form-control-lg form-control-solid"
            value={coupon.max_redemptions}
            onChange={(e) => setCoupon({ ...coupon, max_redemptions: e.target.value })}
          />
          {errors?.max_redemptions && (
            <small className="text-danger">{errors.max_redemptions}</small>
          )}
        </div>
      </div>

      {/* Expires At */}
      <div className="form-group row">
        <label className="col-xl-3 col-lg-3 col-form-label">Expires At</label>
        <div className="col-lg-9 col-xl-6">
          <input
            type="date"
            className="form-control form-control-lg form-control-solid"
            value={coupon.expires_at}
            onChange={(e) => setCoupon({ ...coupon, expires_at: e.target.value })}
          />
          {errors?.expires_at && (
            <small className="text-danger">{errors.expires_at}</small>
          )}
        </div>
      </div>

      {/* Metadata (Optional) */}
      <div className="form-group row">
        <label className="col-xl-3 col-lg-3 col-form-label">Metadata</label>
        <div className="col-lg-9 col-xl-6">
          <input
            type="text"
            className="form-control form-control-lg form-control-solid"
            placeholder='e.g., {"plan":"premium"}'
            value={coupon.metadata}
            onChange={(e) => setCoupon({ ...coupon, metadata: e.target.value })}
          />
          {errors?.metadata && (
            <small className="text-danger">{errors.metadata}</small>
          )}
        </div>
      </div>

      {/* Display Uploaded Image */}
      {image && (
        <div className="form-group row justify-content-center">
          <img
            src={image.type ? URL.createObjectURL(image) : image}
            style={{
              height: "100px",
              width: "100px",
              objectFit: "cover",
            }}
            alt="Coupon Icon"
          />
        </div>
      )}
      {errors?.image && (
        <div className="form-group row justify-content-center">
          <small className="text-danger">{errors.image}</small>
        </div>
      )}

      {/* Submit Button */}
      <div className="d-flex align-items-center justify-content-center">
        {submitValue ? (
          <button
            onClick={handleUpdateProduct}
            className="btn btn-success mr-2"
          >
            <span>Update Coupon</span>
            {loading && (
              <span className="mx-3 spinner spinner-white"></span>
            )}
          </button>
        ) : (
          <button onClick={submitProduct} className="btn btnColor mr-2">
            <span>Add Coupon</span>
            {loading && (
              <span className="mx-3 spinner spinner-white"></span>
            )}
          </button>
        )}
      </div>
    </div>
  ) : null}
</List>

      </Dialog>
    </>
  );
};

export default PromoCode;
